import React, { useEffect, useState } from 'react';
import { CheckCircle, X } from 'lucide-react';
const purchases = [{
  name: 'Matías A.',
  city: 'Posadas',
  country: 'Misiones'
}, {
  name: 'Valeria G.',
  city: 'Corrientes',
  country: 'Argentina'
}, {
  name: 'Ricardo S.',
  city: 'Formosa',
  country: 'Argentina'
}, {
  name: 'Roberto M.',
  city: 'Paraná',
  country: 'Entre Ríos'
}, {
  name: 'Lucía F.',
  city: 'Resistencia',
  country: 'Chaco'
}, {
  name: 'Marcos P.',
  city: 'Neuquén',
  country: 'Argentina'
}, {
  name: 'Sandra R.',
  city: 'Santa Fe',
  country: 'Argentina'
}, {
  name: 'Diego H.',
  city: 'Tucumán',
  country: 'Argentina'
}, {
  name: 'Andrés R.',
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  name: 'María C.',
  city: 'Mérida',
  country: 'México'
}, {
  name: 'Carlos M.',
  city: 'Bogotá',
  country: 'Colombia'
}, {
  name: 'Ana T.',
  city: 'Guayaquil',
  country: 'Ecuador'
}, {
  name: 'Rodrigo S.',
  city: 'Puerto Montt',
  country: 'Chile'
}, {
  name: 'Laura P.',
  city: 'Guatemala',
  country: 'Guatemala'
}, {
  name: 'Sofía M.',
  city: 'Asunción',
  country: 'Paraguay'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const initial = setTimeout(showNext, 6000);
    return () => clearTimeout(initial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const showNext = () => {
    const random = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrent(random);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 12000) + 12000;
      setTimeout(showNext, nextDelay);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed top-4 right-4 z-50 max-w-[270px] md:max-w-[290px] animate-[slideInRight_0.5s_ease-out]" data-id="element-226">
      <div className="bg-brand-paper rounded-xl border border-brand-orange p-3 shadow-[0_8px_30px_rgba(255,122,26,0.35)] flex items-start gap-2.5 relative" data-id="element-227">
        <button onClick={() => setIsVisible(false)} className="absolute -top-2 -right-2 bg-brand-cream text-white rounded-full w-6 h-6 flex items-center justify-center border border-brand-orange" aria-label="Cerrar" data-id="element-228">
          <X className="w-3 h-3" strokeWidth={3} data-id="element-229" />
        </button>
        <div className="bg-brand-green rounded-full p-1.5 shrink-0" data-id="element-230">
          <CheckCircle className="w-4 h-4 text-white" strokeWidth={3} data-id="element-231" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-232">
          <p className="text-[11px] md:text-xs text-white font-bold leading-tight mb-0.5" data-id="element-233">
            <span className="font-display font-bold uppercase" data-id="element-234">
              {current.name}
            </span>{' '}
            de{' '}
            <span className="font-bold" data-id="element-235">
              {current.city}, {current.country}
            </span>
          </p>
          <p className="text-[11px] md:text-xs text-brand-ink font-medium leading-tight mb-1" data-id="element-236">
            acaba de comprar el{' '}
            <span className="font-bold text-brand-orange" data-id="element-237">
              Sistema Acuicultura Pro™
            </span>{' '}
            🐟
          </p>
          <p className="text-[9px] md:text-[10px] text-brand-mute font-bold uppercase tracking-widest" data-id="element-238">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-239">{`
        @keyframes slideInRight {
          from { transform: translateX(120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}